import { Logger } from 'DVWebNodeUtils'
import { MiddlewareAPI, Dispatch, Middleware } from 'redux'
import { DetailPageActions } from '../actions'
import { COUNTER_PACKAGE_PREFIX } from '../utils/utils'

export const loggerMiddleware = (
  logger: Logger,
  isInternal: boolean
): Middleware<DetailPageActions> => (api: MiddlewareAPI) => (
  next: Dispatch<DetailPageActions>
) => (action: DetailPageActions) => {
  logger.count(
    `${COUNTER_PACKAGE_PREFIX}_Action_${action.type.split('/').pop()}`,
    1,
    true
  )
  isInternal && logger.info('Action', action)
  const result = next(action)
  isInternal && logger.info('State', api.getState())
  return result
}
